@if (commPreferenceForm) {
  <div class="container">
    <h1 class="sr-only">{{ pageLabels?.['editCommPreferences.tag_name'] }}</h1>
    <div class="acc-info-btn">
      <gds-utility-action
        [data]="{
          icon: { iconName: 'left-arrow-v2' },
          label: pageLabels?.['address.backCTA'],
          type: 'left-arrow-v2',
          disabled: false,
        }"
        (utilityClicked)="bacToAccInfo()"
      ></gds-utility-action>
    </div>
    <gds-spacer classes="spacer-70"></gds-spacer>
    <gds-heading
      [data]="{ heading: pageLabels?.['accountInfo.communicationPreferences'] }"
      class="A3-W6"
    ></gds-heading>
    <ng-container>
      <gds-spacer classes="spacer-70"></gds-spacer>
      <gds-body
        [data]="{
          description: pageLabels?.['editCommPreferences.description'],
        }"
        class="B1-W3"
      ></gds-body>
      <gds-spacer classes="spacer-50"></gds-spacer>
      <!-- Apply the directive on the wrapper that contains all checkboxes -->
      <div
        [formGroup]="commPreferenceForm"
        uprKeyboardA11y
        [uprKeyboardA11y]="true"
        [querySelect]="'input[type=checkbox]'"
        [autoFocus]="false"
        [timeoutDelay]="100"
        role="group"
        aria-labelledby="communication-group-label"
      >
        <!-- Optional visible group label for SRs -->
        <span id="communication-group-label" class="sr-only">
          {{ pageLabels?.['accountInfo.communicationPreferences'] }}
        </span>
        <gds-input
          ngDefaultControl
          id="orlando"
          class="checkbox-label"
          [data]="{
            primaryLabel: pageLabels?.['accountInfo.universalOrlando'],
            primaryIconTitleText: pageLabels?.['accountInfo.universalOrlando'],
            type: 'checkbox',
            altText: pageLabels?.['editCommPreferences.checkboxAltText'],
            ariaText: pageLabels?.['accountInfo.universalOrlando'],
            required: true,
          }"
          (valueChange)="onPrimaryClick($event)"
          [value]="uor_promos ? 'checked' : ''"
        ></gds-input>
        <gds-spacer classes="spacer-50"></gds-spacer>
        <gds-input
          ngDefaultControl
          id="hollywood"
          class="checkbox-label"
          [data]="{
            primaryLabel: pageLabels?.['accountInfo.universalHollywood'],
            primaryIconTitleText:
              pageLabels?.['accountInfo.universalHollywood'],
            type: 'checkbox',
            altText: pageLabels?.['editCommPreferences.checkboxAltText'],
            ariaText: pageLabels?.['accountInfo.universalHollywood'],
            required: true,
          }"
          (valueChange)="onPrimaryClick($event)"
          [value]="ush_promos ? 'checked' : ''"
        ></gds-input>
        <gds-spacer classes="spacer-50"></gds-spacer>
        <gds-input
          ngDefaultControl
          id="unleashed"
          class="checkbox-label"
          [data]="{
            primaryLabel: pageLabels?.['accountInfo.universalUnleashed'],
            primaryIconTitleText:
              pageLabels?.['accountInfo.universalUnleashed'],
            type: 'checkbox',
            altText: pageLabels?.['editCommPreferences.checkboxAltText'],
            ariaText: pageLabels?.['accountInfo.universalUnleashed'],
            required: true,
          }"
          (valueChange)="onPrimaryClick($event)"
          [value]="uhu_promos ? 'checked' : ''"
        ></gds-input>
        <gds-spacer classes="spacer-50"></gds-spacer>
        <gds-input
          ngDefaultControl
          id="kids"
          class="checkbox-label"
          [data]="{
            primaryLabel: pageLabels?.['accountInfo.universalKidsResorts'],
            primaryIconTitleText:
              pageLabels?.['accountInfo.universalKidsResorts'],
            type: 'checkbox',
            altText: pageLabels?.['editCommPreferences.checkboxAltText'],
            ariaText: pageLabels?.['accountInfo.universalKidsResorts'],
            required: true,
          }"
          (valueChange)="onPrimaryClick($event)"
          [value]="ukr_promos ? 'checked' : ''"
        ></gds-input>
      </div>
    </ng-container>
    <gds-spacer classes="spacer-70"></gds-spacer>
    <gds-sticky-nav-footer
      [data]="{
        button: {
          type: 'primary',
          href: '',
          label: pageLabels?.['addAddress.save'],
          disabled: inputChanged ? 'false' : 'true',
          target: '',
        },
      }"
      (buttonClicked)="saveChanges()"
    ></gds-sticky-nav-footer>
    <gds-spacer classes="spacer-70"></gds-spacer>
  </div>
}
